import instance from "../config/instance.js";
import instanceCommerce from "../config/instanceCommerce.js";

export const allBrands = async () => {
  try {
    const data = await instance({
      url: "/api/getbrands",
      method: "GET",
    }).then((res) => {
      return res.data.allmarcas[0];
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const postCouponData = async (id, credential) => {
  try {
    const data = await instance({
      url: `/api/updatecupon?id=${id}&credencial=${credential}`,
      method: "POST",
    }).then((res) => {
      return res;
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getCoupon = async (id) => {
  try {
    const data = await instance({
      url: `/api/getcupon_1?id=${id}`,
      method: "GET",
    }).then((res) => {
      return res.data;
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getComprobante = async (id, token) => {
  try {
    const response = await instance({
      url: `/api/comprobante/${id}`,
      method: "GET",
      responseType: 'blob', 
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.status !== 200) {
      throw new Error("Error al obtener el comprobante");
    }

    return response;
  } catch (error) {
    console.log(error);
    throw error; 
  }
};

export const getColaboradores = async ( token) => {
  try {
    const response = await instance({
      url: "/api/listar-colaboradores",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.status !== 200) {
      throw new Error("Error al obtener la lista de colaboradores");
    }

    return response.data;
  } catch (error) {
    console.log(error);
    throw error; 
  }
};

export const deleteColaborador = async ({id, token}) => {
  try {
    const response = await instance({
      url: `/api/eliminar-colaborador/${id}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.status !== 200) {
      throw new Error("Error al eliminar colaborador");
    }
    return response;
  } catch (error) {
    console.log(error);
    throw error; 
  }
};

export const activateColaborador = async ({id, token}) => {
  try {
    const response = await instanceCommerce({
      url: `/api/restaurar-colaborador/${id}`,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.status !== 200) {
      throw new Error("Error al activar colaborador");
    }
    return response;
  } catch (error) {
    console.log(error);
    throw error; 
  }
};

export const putColaborador = async ({ id, pwd, token }) => {
  try {
    const response = await instanceCommerce({
      url: `/api/editar-colaborador/${id}`,
      method: "PUT", 
      data: JSON.stringify({password:pwd}),
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    });

    if (response.status !== 200) {
      throw new Error("Error al editar colaborador");
    }

    console.log("Colaborador editado correctamente", response);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};